<!--
  -  Copyright (c) Qwoach LLC 2022. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 20/10/2022
  -->

<template>
	<el-collapse-item v-bind="attrsComputed" :name="nameComputed">
		<slot></slot>
		<template #title v-if="$slots.title"><slot name="title"></slot></template>
	</el-collapse-item>
</template>

<script>
import BaseComponent from "@/core/components/BaseComponent.vue";

export default {
	name: "QwCollapseItem",
	extends: BaseComponent,
	inheritAttrs: false,

	computed: {
		nameComputed() {
			return this.$attrs.name || this.$attrs.title
		},

		attrsComputed(){
			let {onChange, ...rest} = this.$attrs
			return {
				...rest,
				handleItemClick(){
					console.log("QwCollapseItem: handleItemClick = ", ...arguments)
				},
				onChange(){
					console.log("QwCollapseItem: onChange = ", ...arguments)
					if(onChange){
						onChange()
					}
					// this.$emit("change")
				}
			}
		}
	},
}
</script>

<style lang="scss">

.link-title{
	color: $link-color;
	.el-collapse-item__header{
		color: inherit;
		text-decoration: none;
	}
	.el-collapse-item__header:hover{
		color: inherit;
		text-decoration:underline;
	}

}


</style>
